import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../app/api';
import { Associations, fetchStrategyAssociationsPayload, fetchStrategyGetAfslAndPracticeDetailsForAdviserPayload, 
  StrategyAfslAndPracticeDetailsForAdviser } from './types';

export enum StrategyAssociationsActionTypes {
  FetchStrategyAssociations = '@@strategy/FetchStrategyExposure',
  FetchAfslAndModelAssociations = '@@strategy/fetchGetAfslAndPracticeDetailsForAdviser',
}

export enum StrategyAssociationsApiEndpoints {
  fetchStrategyAssociations = '/bff/GetUniverseStrategyExposure',
  fetchAccessControlKeyForStrategy = '/strategies/GetAccessControlKeyForStrategy'
}

export const fetchStrategyAssociations = createAsyncThunk(
  StrategyAssociationsActionTypes.FetchStrategyAssociations,
  async (wrapper: fetchStrategyAssociationsPayload) => {
    const response = await api.get<Associations>(
      `${StrategyAssociationsApiEndpoints.fetchStrategyAssociations}?strategyVersionId=${wrapper.strategyVersionId}` + 
      (wrapper.afslId ? `&afslId=${wrapper.afslId}` : "")
    );
    return response.data;
  }
);

export const fetchAfslAndModelAssociations = createAsyncThunk(
  StrategyAssociationsActionTypes.FetchAfslAndModelAssociations,
  async (wrapper: fetchStrategyGetAfslAndPracticeDetailsForAdviserPayload, { dispatch }) => {

    const response = await api.get<StrategyAfslAndPracticeDetailsForAdviser>(
      `${StrategyAssociationsApiEndpoints.fetchAccessControlKeyForStrategy}?strategyId=${wrapper.strategyId}`
    );

    const [afslId] = response.data.ownerAfslIds ?? [];

    if (wrapper.strategyVersionId !== null && afslId !== undefined) {
      await dispatch(
        fetchStrategyAssociations({
          strategyVersionId: wrapper.strategyVersionId,
          afslId
        })
      ).unwrap();
    }
    return afslId;
  }
);
